// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Firebase configuration is read from environment variables so secrets
// are not committed to source control. Create a local `.env.local` with
// the REACT_APP_FIREBASE_* variables (see .env.example).

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Basic runtime check to help debugging when env vars are missing.
if (!firebaseConfig.apiKey) {
    // During development this will warn; in CI the build will fail if
    // the required env vars are not provided. This avoids committing
    // secrets to the repo.
    // eslint-disable-next-line no-console
    console.warn(
        "Firebase configuration not found in environment. Make sure you created a local .env file or provided CI secrets."
    );
}

// Initialize Firebase app and Realtime Database when config is present.
// If values are missing, initializeApp will still run but Firebase may
// report runtime errors — this is intentional to avoid leaking values.
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
